import { render, staticRenderFns } from "./saveBusiness.vue?vue&type=template&id=31fac1b8&"
import script from "./saveBusiness.vue?vue&type=script&lang=js&"
export * from "./saveBusiness.vue?vue&type=script&lang=js&"
import style0 from "./saveBusiness.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports